import { useState } from 'react';

function americanToDecimal(american) {
	const a = parseFloat(american);
	if (isNaN(a) || a === 0) return NaN;
	if (a > -100 && a < 100) return NaN;
	if (a > 0) return a / 100 + 1;
	return 100 / Math.abs(a) + 1;
}

export const KellyCriterionCalculator = () => {
	const [odds, setOdds] = useState('');
	const [winProbInput, setWinProbInput] = useState('');
	const [bankroll, setBankroll] = useState('');

	const decimal = americanToDecimal(odds);
	const winProb = parseFloat(winProbInput) / 100;
	const bankrollNum = parseFloat(bankroll);

	const hasResults = !isNaN(decimal) && decimal > 1 && !isNaN(winProb) && winProb > 0 && winProb < 1 && !isNaN(bankrollNum) && bankrollNum > 0;

	let results = null;
	if (hasResults) {
		const b = decimal - 1;
		const q = 1 - winProb;
		const kellyFraction = (b * winProb - q) / b;
		const edge = ((winProb * decimal) - 1) * 100;

		const fullKelly = Math.max(0, kellyFraction) * bankrollNum;
		const halfKelly = fullKelly * 0.5;
		const quarterKelly = fullKelly * 0.25;

		results = {
			kellyPct: Math.max(0, kellyFraction * 100),
			fullKelly,
			halfKelly,
			quarterKelly,
			edge,
		};
	}

	const handleReset = () => {
		setOdds('');
		setWinProbInput('');
		setBankroll('');
	};

	return (
		<div>
			<div className="calc-section">
				<h3 className="calc-section-title">Bet Details</h3>
				<div className="calc-grid calc-grid-3">
					<div className="calc-input-group">
						<label className="calc-label">Your Odds (American)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="+150"
							value={odds}
							onChange={(e) => setOdds(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">True Win Probability (%)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="45"
							value={winProbInput}
							onChange={(e) => setWinProbInput(e.target.value)}
						/>
					</div>
					<div className="calc-input-group">
						<label className="calc-label">Bankroll ($)</label>
						<input
							className="calc-input"
							type="text"
							placeholder="10000"
							value={bankroll}
							onChange={(e) => setBankroll(e.target.value)}
						/>
					</div>
				</div>
			</div>

			{results && (
				<div className="calc-results">
					<h4 className="calc-results-title">Kelly Criterion Results</h4>
					<div className="calc-result-row">
						<span className="calc-result-label">Edge</span>
						<span className={`calc-result-value ${results.edge >= 0 ? 'positive' : 'negative'}`}>
							{results.edge >= 0 ? '+' : ''}{results.edge.toFixed(2)}%
						</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Kelly Percentage</span>
						<span className="calc-result-value highlight">{results.kellyPct.toFixed(2)}%</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Full Kelly Stake</span>
						<span className="calc-result-value">${results.fullKelly.toFixed(2)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Half Kelly Stake</span>
						<span className="calc-result-value">${results.halfKelly.toFixed(2)}</span>
					</div>
					<div className="calc-result-row">
						<span className="calc-result-label">Quarter Kelly Stake</span>
						<span className="calc-result-value">${results.quarterKelly.toFixed(2)}</span>
					</div>
				</div>
			)}

			<button className="calc-reset-btn" onClick={handleReset}>Reset</button>
		</div>
	);
};
